import { z } from 'zod';

/**
 * DM-3 — Docs module capabilities (BACKLOG-2026-05-29-docs-module.md).
 *
 * Перечисление abilities для FE `useAbility()` gating и BE middleware
 * `requireDocsCapability()`. Default mapping role → caps в DEFAULT_DOCS_CAPS.
 */
export const DocsAbility = z.enum([
  /** Читать документы. У всех аутентифицированных по умолчанию. */
  'docs:read',
  /** Читать разделы других ролей (по умолчанию у всех — для cross-role consult). */
  'docs:read-cross-role',
  /** Редактировать документы (только admin). */
  'docs:write',
  /** Force overwrite при конфликте версий (admin, фиксируется в audit). */
  'docs:override-conflict',
  /** Откат к версии в git репозитории (admin). */
  'docs:restore-from-git',
  /** Upload скриншотов в MinIO (admin). */
  'docs:upload-screenshot',
]);
export type DocsAbility = z.infer<typeof DocsAbility>;

/**
 * Default mapping role → docs capabilities. Используется в /auth/me для
 * проброса FE и в middleware при проверке прав.
 */
export const DEFAULT_DOCS_CAPS: Record<string, DocsAbility[]> = {
  admin: [
    'docs:read',
    'docs:read-cross-role',
    'docs:write',
    'docs:override-conflict',
    'docs:restore-from-git',
    'docs:upload-screenshot',
  ],
  manager: ['docs:read', 'docs:read-cross-role'],
  accountant: ['docs:read', 'docs:read-cross-role'],
  reviewer: ['docs:read', 'docs:read-cross-role'],
  warehouse: ['docs:read', 'docs:read-cross-role'],
  operator: ['docs:read', 'docs:read-cross-role'],
  viewer: ['docs:read', 'docs:read-cross-role'],
};
